module.exports = __webpack_public_path__ + "static/media/oracle goldengate.fe9c6117.png";